import { ErrorHandler, Injectable } from '@angular/core';

import { environment } from 'environments/environment';



@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  handleError(error: Error): void {
    const chunkFailedPattern = /Loading chunk [\w]+ failed/;

    if (chunkFailedPattern.test(error.message)) {
      if (environment.production) {
        window.location.reload();
      } else {
        if (confirm($localize`:@@global.messages.newVersionTip:A new version is available. Do you want to load the latest version?`)) {
          window.location.reload();
        }
      }
    }
    console.warn(error);
  }
}